import { render, staticRenderFns } from "./EventAddProduct.vue?vue&type=template&id=01ec2d2d&scoped=true&"
import script from "./EventAddProduct.vue?vue&type=script&lang=js&"
export * from "./EventAddProduct.vue?vue&type=script&lang=js&"
import style0 from "./EventAddProduct.vue?vue&type=style&index=0&id=01ec2d2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ec2d2d",
  null
  
)

export default component.exports